import React from 'react';
import { UrgencyBanner } from './components/UrgencyBanner';
import { Hero } from './components/Hero';
import { InitialTestimonials, MoreTestimonials } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { MethodOverview } from './components/MethodOverview';
import { MaterialPreview } from './components/MaterialPreview';
import { FAQ } from './components/FAQ';
import { CostComparison } from './components/CostComparison';
import { Guarantee, Footer } from './components/Footer';
import { FloatingNotification } from './components/FloatingNotification';
import { EmotionalClose } from './components/EmotionalClose';
import { DecorativeDandelions } from './components/DecorativeDandelions';
function TransitionPhrase() {
  return <div className="relative mx-auto max-w-3xl px-6 pb-10 pt-1 text-center md:pb-16" data-id="element-0" data-mp="28ufpkexrnkkn">
      <DecorativeDandelions className="-left-28 -top-12 hidden h-44 w-36 md:block" tone="gold" data-id="element-1" data-mp="28sbend1g9lav" />
      <p className="font-display text-2xl font-bold italic leading-relaxed text-brand-dark md:text-3xl" data-id="element-2" data-mp="23t8gmcjw0fce">
        La próxima semana en tu consultorio puede ser diferente.
      </p>
    </div>;
}
export function App() {
  return <div className="min-h-screen overflow-hidden bg-brand-surface font-sans text-brand-text selection:bg-brand-yellowLight selection:text-brand-deep" data-id="element-3" data-mp="3rc9hqi3ghy2i">
      <UrgencyBanner data-id="element-4" data-mp="5gel8p3rovc" />
      <main data-id="element-5" data-mp="82jt1oitsae">
        <Hero data-id="element-6" data-mp="2zl39tfhhuw2o" />
        <InitialTestimonials data-id="element-7" data-mp="2zld1r8m3ndb0" />
        <PainPoints data-id="element-8" data-mp="2zm4vedw4z0yn" />
        <MethodOverview data-id="element-9" data-mp="2zmwj72jhrued" />
        <MaterialPreview data-id="element-10" data-mp="2znfy0adui2o6" />
        <MoreTestimonials data-id="element-11" data-mp="33m5bs42spm8c" />
        <Guarantee data-id="element-12" data-mp="33ngfk3w8qtzg" />
        <FAQ data-id="element-13" data-mp="33myix65o2dr0" />
        <CostComparison data-id="element-14" data-mp="33oi1j3esp0vy" />
        <TransitionPhrase data-id="element-15" data-mp="38l8idsyfc0if" />
        <EmotionalClose data-id="element-16" data-mp="38l04bxqkep5n" />
      </main>
      <Footer data-id="element-17" data-mp="38num1hi71vvd" />
      <FloatingNotification data-id="element-18" data-mp="3dkuw03i5zirr" />
    </div>;
}